import React from 'react';

export default function IndexSectionApplication11() {
    return (
        <React.Fragment>
            <>
                <section className="bg-green-100 py-20">
                    <div className="container mx-auto px-4">
                        <div className="flex flex-wrap items-center -m-4">
                            <div className="w-full lg:w-5/12 p-4 mb-10 lg:mb-0">
                                <img className="mx-auto block" style={{maxHeight: 556}}
                                     src="https://static.shuffle.dev/uploads/files/91/912295578c198379538e8973cd408b5d4407df70/3-photos.png"
                                     alt/>
                            </div>
                            <div className="w-full lg:w-7/12 p-4">
                                <h1 className="font-heading text-4xl lg:text-5xl font-bold mb-4">Expand your food social
                                    connections</h1>
                                <p className="text-gray-600 mb-6 max-w-lg">Connect with your friends, share reviews, and
                                    more...</p>
                                <div className="flex flex-wrap gap-4"><a
                                    className="px-6 py-3 block text-center w-full sm:w-auto bg-orange-900 text-white text-sm font-bold hover:bg-orange-800 focus:ring focus:ring-orange-700 transition duration-200"
                                    href="#">Connect</a></div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        </React.Fragment>
    );
}

